import { render } from "./emailconfig.vue?vue&type=template&id=b4f7a3a2&scoped=true"
import script from "./emailconfig.vue?vue&type=script&lang=js"
export * from "./emailconfig.vue?vue&type=script&lang=js"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4f7a3a2"]])

export default __exports__